import React, { Component } from "react";

/**
 * The raw data, which is 50,000 should be formatted in the following form $0.05M
 * with the following steps:
 * - divided by 1,000,000
 * - presented in 2 decimal places
 * - have the letter "M" after the last digit
 * - prefixed with $ symbol in front of the first digit
 */
class PromoSpendTextMasking extends Component {
  render() {
    let value = this.props.value;
    value = (value / 1000000).toFixed(2);

    return <span>{`$${value}M`}</span>;
  }
}

export default PromoSpendTextMasking;



// WEBPACK FOOTER //
// ./src/components/promo-spend/PromoSpendTextMasking.js